import permissions from '../../permissions'

const DATA_PROCESS_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.VISUALIZE,
    tag: permissions.DATA_PROCESSES.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.DATA_PROCESSES.CREATE,
  },
  {
    name: 'Revisar',
    tag: permissions.DATA_PROCESSES.REVIEW,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.DESTROY,
    tag: permissions.DATA_PROCESSES.DESTROY,
  },
]

export default DATA_PROCESS_LIST
